export default __webpack_public_path__ + "static/media/B0005.5c20761c.png";